import { CLIENT, NAV_LINKS } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050505] py-12">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 sm:flex-row sm:items-end sm:justify-between lg:px-10">
        <div>
          <p className="font-display text-2xl font-semibold uppercase tracking-tight text-neutral-100">
            Sovan<span className="text-electric"> Gourav Rout</span>
          </p>
          <p className="mt-2 text-sm text-neutral-500">{CLIENT.role} · {CLIENT.location}</p>
          <a href={`mailto:${CLIENT.email}`} data-testid="footer-email-link" className="mt-2 block text-sm font-semibold text-neutral-300 transition-colors hover:text-electric">
            {CLIENT.email}
          </a>
        </div>
        <nav aria-label="Footer navigation">
          <ul className="flex flex-wrap gap-x-6 gap-y-2">
            {NAV_LINKS.map((link) => (
              <li key={link.href}>
                <a href={link.href} data-testid={`footer-link-${link.label.toLowerCase()}`} className="text-[11px] font-bold uppercase tracking-[0.2em] text-neutral-500 transition-colors hover:text-electric">
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="mx-auto mt-10 max-w-7xl border-t border-white/5 px-6 pt-6 lg:px-10">
        <p className="text-xs text-neutral-600">
          © {new Date().getFullYear()} {CLIENT.name}. Engineering sound. Creating experiences.
        </p>
      </div>
    </footer>
  );
}
